export default "__VITE_ASSET__6cAI74iK__"